export default function Loader({ message = "Loading..." }) {
    return (
      <div className="flex items-center justify-center h-full text-gray-600">
        <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-blue-500 mr-2"></div>
        <span className="text-lg">{message}</span>
      </div>
    );
  }
  